import { render } from "./ConvertAllDetailTaskToTestForm.vue?vue&type=template&id=772fbc0f&scoped=true"
import script from "./ConvertAllDetailTaskToTestForm.vue?vue&type=script&lang=js"
export * from "./ConvertAllDetailTaskToTestForm.vue?vue&type=script&lang=js"

import "./ConvertAllDetailTaskToTestForm.vue?vue&type=style&index=0&id=772fbc0f&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772fbc0f"]])

export default __exports__